import App from './App.vue';
import { router, vuetify, initVueWithAuth } from '@/myq-core';
import { getRoutes } from '@/views/routes';
import Highcharts from 'highcharts';
import Stock from 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue';

console.log('MyQ Reports', '2025-04-21', 'v3');

async function loadApp() {
  // trickery to get refreshing to work with multi enterprise routes
  let routes;
  const userString = localStorage.getItem('user');
  if (userString) {
    const user = JSON.parse(userString);
    const enterprise = user?.user?.organization?.enterpriseClient;
    routes = getRoutes(enterprise);
  }
  Stock(Highcharts);
  const app = await initVueWithAuth({
    app: App,
    routes,
    vuetify,
    router,
  });
  app.use(HighchartsVue);
  app.mount('#app');
}

loadApp();
